/*
 * Author Amit Ranjan Mohanty<amit.ranjanmohanty@vodafone.com>
 * Staging is the default environment for staging.
 */

import environment, { Environment } from "./base";

const baseApi = "https://api.hub.ucc-stg.vodafone.com";
const legacyBaseApi = "https://api.connectedcomms.click";
const env = environment(baseApi, legacyBaseApi, "staging");

const developmentEnv: Environment = {
  ...env,
  portalUrl: "https://hub.ucc-stg.vodafone.com",
  supportSiteUrl: "https://support.hub.ucc-stg.vodafone.com",
  baseApi: baseApi,
  legacyBaseApi: legacyBaseApi,
  api: {
    ...env.api,
  },
  isProduction: false,
  isDevelopment: false,
  isStaging: true,
};

export default developmentEnv;
